import { useContext, useState } from "react"
import CaixaContext from "../../../contexts/caixaContext"
import { useSnackbar } from "../../../utils/notificacoes"

import { RegistrarLogErro } from "../../../services/clientefiel"
import { dataAtualFormatada, fecharCaixa } from "../../../services/controlecaixa"
import { imprimirFechamentoCaixa } from "../../../services/historicoCaixa"
import { gerarTextoFechamento } from "../../../services/textoFechamento"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"

import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardMedia from "@material-ui/core/CardMedia"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { Print } from "@material-ui/icons"
import { Col, Row } from "react-bootstrap"
import CAIXA_ICON from "../../../assets/icons/svg/033-admin.svg"
import ConfirmarFechamento from "./ConfirmarFechamento"

const useStyles = makeStyles(theme => ({}))

export default function CardCaixas({ caixaAberto }) {
    const { handleBuscarCaixa, handleBuscarCaixasAbertos, estabelecimentoSelecionado } =
        useContext(CaixaContext)

    const classes = useStyles()
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()
    const setLoading = useLoadingStore(s => s.setLoading)
    const mandarImprimir = useAppStore(s => s.mandarImprimir)
    const configuracoes = useAppStore(s => s.configuracoes)

    const [confirmarFechamento, setConfirmarFechamento] = useState(false)

    // Fecha o caixa direto da listagem (sem precisar abri-lo), com confirmacao previa.
    const handleFecharCaixa = async () => {
        try {
            setLoading(true)
            const resposta = await fecharCaixa(caixaAberto.id, autorizacao)
            if (resposta.status >= 300) {
                enqueueSnackbar(resposta.message, { variant: "error" })
            } else {
                enqueueSnackbar(resposta.message || "Caixa fechado com sucesso.", {
                    variant: "success",
                })
                handleBuscarCaixasAbertos(estabelecimentoSelecionado)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleFecharCaixaCard", caixaAberto)
        } finally {
            setConfirmarFechamento(false)
            setLoading(false)
        }
    }

    // Imprime o fechamento reusando o mesmo fluxo da tela do caixa aberto.
    const handleImprimir = async () => {
        try {
            setLoading(true)
            const resp = await imprimirFechamentoCaixa(autorizacao, caixaAberto.id)
            if (resp?.retornoErro || !resp?.cabecalho) {
                enqueueSnackbar(
                    resp?.mensagem || "Não foi possível obter o fechamento do servidor.",
                    { variant: "error" }
                )
                return
            }
            const largura = configuracoes?.user?.parametros?.colunasPorLinhaImpressao
            const texto = "\n\n" + gerarTextoFechamento(resp, largura)
            mandarImprimir({ texto, numeroDaImpressora: 1, isResumo: true })
        } catch (error) {
            RegistrarLogErro(error, "handleImprimirCard", caixaAberto)
            enqueueSnackbar("Erro ao imprimir o fechamento.", { variant: "error" })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Card className={classes.root}>
            {/* Acoes rapidas no topo, fora da area clicavel (nao disparam a abertura) */}
            <CardActions style={{ justifyContent: "space-between", padding: "6px 8px" }}>
                <Button size="small" startIcon={<Print />} onClick={handleImprimir}>
                    Imprimir
                </Button>
                <Button
                    size="small"
                    style={{ color: "var(--cor-erro)" }}
                    onClick={() => setConfirmarFechamento(true)}
                >
                    Fechar
                </Button>
            </CardActions>

            {/* Clicar no meio do card ABRE o caixa (detalhamento) */}
            <CardActionArea
                onClick={() => {
                    handleBuscarCaixa(caixaAberto.id)
                }}
                style={{ alignItems: "normal" }}
            >
                <Row
                    style={{
                        margin: 0,
                        width: "100%",
                        padding: "1em",
                        alignItems: "center",
                    }}
                >
                    <Col xs={3} md={3} lg={3} style={{ padding: 0 }}>
                        <CardMedia
                            component="img"
                            className={"logoLojas"}
                            style={{ opacity: "0.65" }}
                            alt={caixaAberto.id}
                            image={CAIXA_ICON}
                            title={caixaAberto.id}
                        />
                    </Col>

                    <Col xs={9} md={9} lg={9}>
                        <Typography variant="body2" color="textSecondary" component="p">
                            {dataAtualFormatada(new Date(caixaAberto.abertoEm))}
                        </Typography>

                        <Typography gutterBottom component="h2">
                            {caixaAberto.nomeAbertura}
                        </Typography>

                        {caixaAberto.permissoesCaixa.map((idTipo, index) => (
                            <span key={index}> • {idTipo.nome}</span>
                        ))}
                    </Col>
                </Row>

                <Typography
                    variant={"button"}
                    style={{ textAlign: "center", padding: "3px", display: "block" }}
                    className={"botaoVerde naoArredondado"}
                >
                    ABERTO
                </Typography>
            </CardActionArea>

            {confirmarFechamento && (
                <ConfirmarFechamento
                    open={confirmarFechamento}
                    setOpen={setConfirmarFechamento}
                    handleFecharCaixa={handleFecharCaixa}
                />
            )}
        </Card>
    )
}
